import React from "react";
import EditCampaign from "@/partial/campaign/edit-campaign";

const EditCampaignPage: React.FC = () => {
  return <EditCampaign />;
};

export default EditCampaignPage;
